import { render, staticRenderFns } from "./EntriesSync.vue?vue&type=template&id=0d07044c&scoped=true"
import script from "./EntriesSync.vue?vue&type=script&lang=js"
export * from "./EntriesSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07044c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d07044c')) {
      api.createRecord('0d07044c', component.options)
    } else {
      api.reload('0d07044c', component.options)
    }
    module.hot.accept("./EntriesSync.vue?vue&type=template&id=0d07044c&scoped=true", function () {
      api.rerender('0d07044c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/EntriesSync.vue"
export default component.exports